import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';

// Components
import GlobalHeaderSearch from './components/GlobalHeaderSearch/GlobalHeaderSearch';
import AddToCartComponent from './components/AddToCart/AddToCartComponent';
import CartDropdownComponent from './components/CartDropdown/CartDropdownComponent';
import CartComponent from './components/Cart/CartComponent';
import VatPromptComponent from './components/VatPrompt/VatPromptComponent';
import PriceDisplayComponent from './components/PriceDisplay/PriceDisplayComponent';
// Modules
import CheckoutModule from './modules/Checkout/CheckoutModule';
import ProductShowWrapperModule from './modules/ProductShowWrapper/ProductShowWrapperModule';
import RegisterUserModule from './modules/RegisterUser/RegisterUserModule';
import CustomerEditModule from './modules/CustomerEdit/CustomerEditModule';


Vue.use(InstantSearch);

const app = new Vue({
  el: '#app',

  components: {
    AddToCartComponent,
    PriceDisplayComponent,
    CartDropdownComponent,
    CartComponent,
    GlobalHeaderSearch,
    VatPromptComponent,
    CheckoutModule,
    ProductShowWrapperModule,
    RegisterUserModule,
    CustomerEditModule,
  },
});
